import { isPc } from '//th.roborock.com/cdn/shop/t/3/assets/ro-os-check.js?v=112419611283278330061749456019';
import '//th.roborock.com/cdn/shop/t/3/assets/RoLoading.js?v=95620367327129964401780458821';
import { ready } from '//th.roborock.com/cdn/shop/t/3/assets/GA4-track-directive-core.js?v=168902421192439441311790229254';
import { trackReport } from '//th.roborock.com/cdn/shop/t/3/assets/GA4-track-directive-report.js?v=104115401213510859531780561163';

function initializeModals() {
  const modals = document.querySelectorAll('.product-channel-modal');

  modals.forEach((modal) => {
    // 如果已经初始化过，则跳过
    if (modal._initialized) return;

    const channelArea = modal.querySelector('.product-channel-area');
    const productArea = modal.querySelector('.product-channel-product-area');
    const source = modal.querySelector('.product-blocks-source');
    const channelBox = modal.querySelector('.product-channel-box');
    let selectionVersion = 0;
    let closeTimer = null;

    if (!source || !productArea || !channelArea) return;

    /**
     * 将 theme blocks 渲染源（.product-blocks-source）中的元素
     * 提取并分发到产品区和渠道区。
     */
    (function extractBlocks() {
      // 将产品卡片移至产品选择区
      var productCards = source.querySelectorAll('.product-channel-product-item');
      productCards.forEach(function (card) {
        productArea.appendChild(card);
      });

      // 将渠道分组移至渠道选择区
      source.querySelectorAll('.product-channel-group').forEach(function (group) {
        var prefix = group.getAttribute('data-prefix');
        if (prefix) {
          // 兼容处理：去除首尾空格并使用正则将中间的空格替换为单横杠 '-'
          var cleanPrefix = prefix.trim().replace(/\s+/g, '-');
          var seoClass = cleanPrefix + '-recommend-channel-purchase';
          group.querySelectorAll('.product-channel-item').forEach(function (link) {
            link.classList.add(seoClass);
          });
        }
        channelArea.appendChild(group);
      });
    })();

    /**
     * 展示指定产品对应的渠道列表
     */
    async function showChannel(event, clickedElement) {
      if (event && event.stopPropagation) event.stopPropagation();

      const slug = clickedElement.getAttribute('data-product-slug');
      const blockId = clickedElement.getAttribute('data-block-id');
      const currentSelection = ++selectionVersion;
      modal.querySelector('.product-channel-body').setAttribute('ro-loading', 'false');

      // 高亮当前选中的产品
      setProductClickStyle(clickedElement);

      // PAD/Mobile：始终折叠非选中商品
      if (!isPc()) {
        const allItems = modal.querySelectorAll('.product-channel-product-item');
        allItems.forEach(function (item) {
          if (item !== clickedElement) {
            item.classList.add('product-channel-product-item--collapsed');
          } else {
            item.classList.remove('product-channel-product-item--collapsed');
          }
        });
      }

      // 隐藏所有渠道分组，仅显示当前产品对应的那组
      let activeGroup = null;

      if (slug) {
        // 动态渠道按 block 匹配分组，同 slug 的不同型号也保持独立。
        console.log('渲染～接口配置');
        modal.querySelectorAll('.product-channel-group').forEach(function (group) {
          const isActive = group.getAttribute('data-product-id') === blockId;
          group.style.display = isActive ? 'contents' : 'none';
          if (isActive) activeGroup = group;
        });

        if (activeGroup) {
          const rendered = await fetchAndRenderChannels(slug, activeGroup, currentSelection);
          // 型号已切换或弹窗已关闭时，忽略旧请求的展示结果。
          if (currentSelection !== selectionVersion) return;
          if (!rendered) {
            channelBox.style.display = 'none';
            return;
          }
        }
      } else {
        // 原有逻辑：通过 data-product-id 匹配手动配置的 block
        console.log('渲染～手动配置');
        modal.querySelectorAll('.product-channel-group').forEach(function (group) {
          const isActive = group.getAttribute('data-product-id') === blockId;
          group.style.display = isActive ? 'contents' : 'none';
          if (isActive) activeGroup = group;
        });
      }

      // 展示渠道区
      channelBox.style.display = activeGroup ? 'block' : 'none';

      // PC 端：如果点击的产品对应的渠道数超过 6 个，则滚动到渠道区
      if (isPc() && activeGroup) {
        const productCount = modal.querySelectorAll('.product-channel-product-item').length;
        const channelCount = activeGroup.querySelectorAll('.product-channel-item').length;
        if (productCount > 5 || channelCount > 6) {
          channelBox.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    /**
     * PAD/Mobile：重置产品列表
     */
    function resetProductList() {
      selectionVersion += 1;
      modal.querySelector('.product-channel-body').setAttribute('ro-loading', 'false');
      modal.querySelectorAll('.product-channel-product-item').forEach(function (item) {
        item.classList.remove('product-channel-product-item--collapsed');
        item.classList.remove('product-channel-product-item-active');
      });
      channelBox.style.display = 'none';
      modal.querySelectorAll('.product-channel-group').forEach(function (group) {
        group.style.display = 'none';
        // 清除动态加载的渠道以便下次重新获取
        if (group.dataset.channelsLoaded) {
          group.querySelectorAll('.product-channel-item').forEach(function (el) { el.remove(); });
          delete group.dataset.channelsLoaded;
        }
      });
    }

    /**
     * 设置产品选中高亮样式
     */
    function setProductClickStyle(clickedElement) {
      modal.querySelectorAll('.product-channel-product-item').forEach(function (item) {
        item.classList.remove('product-channel-product-item-active');
      });
      clickedElement.classList.add('product-channel-product-item-active');
    }

    /**
     * 根据 product_slug 从接口获取渠道数据，动态渲染到 group 容器
     * @param {string} slug
     * @param {HTMLElement} groupEl
     * @returns {Promise} 是否成功加载渠道
     */
    async function fetchAndRenderChannels(slug, groupEl, currentSelection) {
      if (!slug) return false;
      // 已加载过的直接返回 true，表示数据就绪
      if (groupEl.dataset.channelsLoaded) return true;

      // 在 product-channel-body 容器内调起指令式 loading
      const bodyEl = modal.querySelector('.product-channel-body');
      bodyEl.setAttribute('ro-loading', 'true');

      try {
        const res = await axios.post('/a/ores/channel/getSalesChannels', { slug });
        if (currentSelection !== selectionVersion) return false;

        if (res.data && res.status === 200 && Array.isArray(res.data.data.list)) {
          const channels = res.data.data.list;
          if (channels.length === 0) return false;

          // 按 sort 升序排列（接口已保证排序，前端做防御性处理）
          channels.sort(function (a, b) { return a.sort - b.sort; });

          // 拼接与 recommend-channel-item 一致的 DOM 结构
          const fragment = document.createDocumentFragment();
          channels.forEach(function (ch) {
            const link = document.createElement('a');
            link.className = 'product-channel-item GA4-buy-now-market';
            link.href = ch.channelLink;
            link.target = '_blank';
            link.rel = 'nofollow';
            link.setAttribute('aria-label', ch.channelName);

            const img = document.createElement('img');
            img.className = 'img-fluid lazyload';
            img.src = ch.channelLogo;
            img.alt = ch.channelName;

            const nameSpan = document.createElement('span');
            nameSpan.className = 'product-channel-name';
            nameSpan.style.display = 'none';
            nameSpan.textContent = ch.channelName;

            link.appendChild(img);
            link.appendChild(nameSpan);
            fragment.appendChild(link);
          });

          groupEl.appendChild(fragment);
          groupEl.dataset.channelsLoaded = 'true';
          return true;
        }

        return false;
      } catch (err) {
        console.warn('[ChannelModal] 获取渠道数据失败:', slug, err);
        return false;
      } finally {
        // 请求结束（成功/失败均关闭 loading）
        if (currentSelection === selectionVersion) bodyEl.setAttribute('ro-loading', 'false');
      }
    }

    /**
     * 为每个产品项绑定点击事件
     */
    function productParameters(item) {
      const items = Array.from(productArea.querySelectorAll('.product-channel-product-item'));
      return {
        module_name: modal._trackingContext?.moduleName || 'Product Display Buy Popup',
        product_name: item.querySelector('.product-channel-product-name')?.textContent.trim() || '',
        index_num: String(items.indexOf(item) + 1),
      };
    }

    function isActivityPopup() {
      return modal._trackingContext?.source === 'activity-product-display';
    }

    // 渠道监听属于弹窗实例，同时覆盖手动和异步生成的渠道。
    channelArea.addEventListener('click', event => {
      if (!modal._isOpen) return;
      const link = event.target.closest('.product-channel-item');
      if (!link || !channelArea.contains(link)) return;
      const href = (link.getAttribute('href') || '').trim();
      if (!href || /^(javascript:|#)/i.test(href)) return;
      const group = link.closest('.product-channel-group');
      const item = Array.from(productArea.querySelectorAll('.product-channel-product-item'))
        .find(product => product.dataset.blockId === group?.dataset.productId);
      if (!item) return;
      const parameters = productParameters(item);
      parameters.button_name = link.querySelector('.product-channel-name')?.textContent.trim() || '';
      if (isActivityPopup()) {
        if (modal._trackingContext.trackEvents !== false) {
          trackReport({event_name: 'buy_now', event_parameters: parameters});
        }
      } else {
        delete parameters.index_num;
        parameters.module_name = modal._trackingContext?.moduleName || window.Ga4_Channel_ModuleName;
        trackReport({event_name: 'store_entry', event_parameters: parameters});
      }
    });

    function setProductClick() {
      modal.querySelectorAll('.product-channel-product-item').forEach(function (item) {
        item.addEventListener('click', async function (event) {
          if (!modal._isOpen) return;
          if (!isPc() && this.classList.contains('product-channel-product-item-active')) {
            event.stopPropagation();
            resetProductList();
            return;
          }
          if (isActivityPopup() && modal._trackingContext.trackEvents !== false) {
            trackReport({event_name: 'buy_now', event_parameters: productParameters(this)});
          }
          await showChannel(event, this);
        });
        item.addEventListener('keydown', event => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          item.click();
        });
      });
    }

    /**
     * PC 端量测高度
     */
    function fixChannelAreaMinHeight() {
      const productCount = modal.querySelectorAll('.product-channel-product-item').length;
      if (!isPc() || productCount > 5) return;

      const groups = channelArea.querySelectorAll('.product-channel-group');
      if (groups.length === 0 || groups.length === 1) return;

      channelBox.style.visibility = 'hidden';
      channelBox.style.display = 'block';

      let maxHeight = 0;
      groups.forEach(function (group) {
        group.style.display = 'contents';
        const h = channelArea.offsetHeight;
        if (h > maxHeight) maxHeight = h;
        group.style.display = 'none';
      });

      channelBox.style.display = 'none';
      channelBox.style.visibility = '';

      if (maxHeight > 0) {
        channelArea.style.minHeight = maxHeight + 'px';
      }
    }

    // 初始化点击
    setProductClick();

    // 暴露打开/关闭方法给实例
    modal._open = function(context = {}) {
      clearTimeout(closeTimer);
      // 活动入口需要独立重置；旧新品页入口保留原有动态渠道缓存。
      if (context.source === 'activity-product-display') resetProductList();
      modal._trackingContext = context;
      modal._isOpen = true;
      modal.style.display = 'block';

      if (!isPc()) {
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            modal.classList.add('is-open');
          });
        });
      }

      if (!modal._channelHeightFixed) {
        fixChannelAreaMinHeight();
        modal._channelHeightFixed = true;
      }

      const productItems = modal.querySelectorAll('.product-channel-product-item');
      if (productItems.length === 1) {
        showChannel({ stopPropagation: function () {} }, productItems[0]);
      }
    };

    modal._close = function(event) {
      if (event) event.stopPropagation();
      selectionVersion += 1;
      modal.querySelector('.product-channel-body').setAttribute('ro-loading', 'false');
      modal._trackingContext = null;
      modal._isOpen = false;

      if (!isPc()) {
        modal.classList.remove('is-open');
        closeTimer = setTimeout(function () {
          modal.style.display = 'none';
          modal.querySelectorAll('.product-channel-product-item').forEach(function (item) {
            item.classList.remove('product-channel-product-item--collapsed');
          });
        }, 350);
      } else {
        modal.style.display = 'none';
      }

      channelBox.style.display = 'none';
      modal.querySelectorAll('.product-channel-group').forEach(function (group) {
        group.style.display = 'none';
      });
      modal.querySelectorAll('.product-channel-product-item').forEach(function (item) {
        item.classList.remove('product-channel-product-item-active');
      });
    };

    // 绑定内部关闭事件
    const closeBtn = modal.querySelector('.product-channel-close');
    if (closeBtn) closeBtn.addEventListener('click', (e) => modal._close(e));

    const handle = modal.querySelector('.product-channel-handle');
    if (handle) handle.addEventListener('click', (e) => modal._close(e));

    const overlay = modal.querySelector('.product-channel-overlay');
    if (overlay) overlay.addEventListener('click', (e) => modal._close(e));

    modal._initialized = true;
  });

  document.dispatchEvent(new CustomEvent('product-channel:ready'));
}

function getChannelModalByKey(key) {
  if (!key || !key.trim()) return null;
  const matches = Array.from(document.querySelectorAll('.product-channel-modal'))
    .filter(modal => modal._initialized && modal.dataset.channelModalKey === key.trim()
      && modal.querySelector('.product-channel-product-item'));
  // 标识重复时不猜测目标，避免打开错误产品的弹窗。
  return matches.length === 1 ? matches[0] : null;
}

window.productChannelData = {
  getChannelModalByKey,
  openChannelModalByKey(key, context = {}) {
    const modal = getChannelModalByKey(key);
    if (!modal) return false;
    modal._open(context);
    return true;
  },
  openChannelModal(moduleName, index = 0) {
    const modal = document.querySelectorAll('.product-channel-modal')[index];
    window.Ga4_Channel_ModuleName = moduleName;
    if (!modal || typeof modal._open !== 'function') return false;
    modal._open({moduleName});
    return true;
  },
};

// 同一模块资源由多个 Section 引用时，只注册一次全局监听。
if (!window.__productChannelTriggerBound) {
  window.__productChannelTriggerBound = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('.show-product-channel-new');
    if (!button) return;
    const buyNowLinkDom = document.querySelector('#recommend-buy-now-link');
    const buyNowLink = buyNowLinkDom?.getAttribute('href')?.trim();
    if (buyNowLinkDom) {
      window.location.href = buyNowLink;
      return;
    }
    const compareIndex = button.getAttribute('data-compare-index');
    if (compareIndex) {
      const index = parseInt(compareIndex, 10);
      window.productChannelData.openChannelModal('compare', isNaN(index) ? 0 : index);
    } else {
      window.productChannelData.openChannelModal('kv');
    }
  });
  document.addEventListener('shopify:section:load', initializeModals);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.product-channel-modal').forEach(modal => {
      modal._close?.();
      modal._initialized = false;
    });
    document.dispatchEvent(new CustomEvent('product-channel:ready'));
  });
}

ready(initializeModals);
